import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import HousekeepingOnboardStructure from "../../components/staff-onboarding/HousekeepingOnboardStructure";

const HousekeepingOnboard = () => {
  const userInfoData = useSelector(selectUser) || {};

  return (
    <HelmetWrapper title="WTF: Housekeeping Onboard">
      <Container className="bg-cloud-k px-50px" fluid>
        <HousekeepingOnboardStructure userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default HousekeepingOnboard;
